import { Link, useParams } from "react-router-dom";

// const formatNaira = (amount) =>
//   new Intl.NumberFormat("en-NG", {
//     style: "currency",
//     currency: "NGN",
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   }).format(Number(amount || 0));

export const PaymentResultPage = ({ type }) => {
  const { token } = useParams();

  const retryUrl = `/pay/${encodeURIComponent(token || "")}`;
  const isSuccess = type === "success";

  const title = isSuccess ? "Payment successful" : "Payment not completed";
  //   const subtitle = isSuccess ? "PAYMENT CONFIRMED" : "PAYMENT NOT COMPLETED";
  const friendlyMessage = isSuccess
    ? "Thanks. Your payment has been received and credited successfully."
    : "We could not verify this payment yet. Please try again.";

  return (
    <div className="min-h-screen bg-grey-50 satoshi text-grey-900">
      <header className="flex h-16 items-center justify-between border-b border-grey-200 bg-white px-4 sm:h-[76px] sm:px-8 lg:px-[72px]">
        <a href="/" aria-label="MyCardGlobal home">
          <img
            className="h-auto max-h-[42px] w-24 object-contain sm:w-28"
            src="/logo.svg"
            alt="MyCardGlobal"
          />
        </a>
        <span className="inline-flex items-center gap-2 text-xs font-medium text-grey-600 sm:text-[13px]">
          <span
            className="h-2 w-2 rounded-full bg-green shadow-[0_0_0_3px_rgba(65,147,94,0.12)]"
            aria-hidden="true"
          />
          Secure payment
        </span>
      </header>

      <main className="mx-auto w-[calc(100%-2rem)] max-w-[520px] py-10 sm:py-16">
        <section className="rounded-2xl border border-grey-200 bg-white p-6 text-center shadow-sm sm:p-8">
          <span
            className={`mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full text-[30px] font-bold ${
              isSuccess ? "bg-green/10 text-green" : "bg-pink/10 text-pink"
            }`}
          >
            {isSuccess ? "✓" : "!"}
          </span>

          <h1 className="mt-2 text-[28px] font-bold leading-[32px] tracking-[-0.02em] text-deep-primary sm:text-[34px] sm:leading-[38px]">
            {title}
          </h1>

          <p className="mt-3 text-sm text-grey-600">{friendlyMessage}</p>

          <Link
            to={retryUrl}
            className="soft-shrink mt-6 inline-flex w-full items-center justify-center rounded-[8px] border border-primary bg-primary px-4 py-3 text-xs font-bold text-white md:text-sm"
          >
            {isSuccess ? "Make another payment" : "Try again"}
          </Link>
        </section>

        <Link
          className="mx-auto mt-5 block w-fit text-sm font-semibold text-primary hover:underline"
          to={retryUrl}
        >
          Back to payment link
        </Link>
      </main>
    </div>
  );
};
